import { app } from '../../../../../app';
import { Controller } from './hard-token-importer-csv.controller';

app.component('hardTokenImporterCsv', {
    templateUrl: require('./hard-token-importer-csv.html'),
    controller: Controller,
    bindings: {
        type: '<',
        otpType: '<',
        tokens: '<',
        onChange: '&'
    }
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/hard-token-importer-csv/hard-token-importer-csv.component.js